import { store } from '@betacrew/jars-flux'

export const componentKey = "BOI/MANAGE_BOI";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setBoiGridRecords: (state, action) => {
            state.boiGridRecords = action.payload;
        },
        setBoiGridSelectedRecords: (state, action) => {
            state.boiGridSelectedRecords = action.payload;
        },
        setSelectedFormStatusOption: (state, action) => {
            state.selectedFormStatusOption = action.payload;
        },
        setOpenPaymentDrawer: (state, action) => {
            state.openPaymentDrawer = action.payload;
        },
        setSelectedReportingCompanyForGrid: (state, action) => {
            state.selectedReportingCompanyForGrid = action.payload;
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setReloadBoiGridRecords: (state, action) => {
            state.reloadBoiGridRecords = action.payload;
        },
        setShowSubmitFormConfirmationPopupOnSubscription: (state, action) => {
            state.showSubmitFormConfirmationPopupOnSubscription = action.payload;
        },
        setReferenceNumberOnFormSubmissionWithoutPayment: (state, action) => {
            state.referenceNumberOnFormSubmissionWithoutPayment = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },

    },
    initialReducerState: {
        loadingState: false,
        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: false,
            Skip: 0,
            totalRecords: 10,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        
        boiGridRecords: [],
        boiGridSelectedRecords: [],
        selectedFormStatusOption: {label: "", value: ""},
        openPaymentDrawer: false,
        selectedReportingCompanyForGrid: {label: "", value: ""},
        payersList: [],
        reloadBoiGridRecords: false,
        showSubmitFormConfirmationPopupOnSubscription: false,
        referenceNumberOnFormSubmissionWithoutPayment: null,
    }
});

export const { setLoadingState, setPaginationState, setBoiGridRecords, setBoiGridSelectedRecords, setSelectedFormStatusOption, setOpenPaymentDrawer, setSelectedReportingCompanyForGrid, setPayersList, setReloadBoiGridRecords, setShowSubmitFormConfirmationPopupOnSubscription, setReferenceNumberOnFormSubmissionWithoutPayment,setPayerDropdownPagination } = actions;